import axios from "axios";
import authHeader from "@/services/auth-header";

const main = "api/BytePro";
const sub = "PartyMisc";

class PartyMiscService {
  get(fileDataId) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/${main}/${sub}/${fileDataId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  update(partyMisc, fileDataId) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/${main}/${sub}/${fileDataId}`,
        partyMisc,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new PartyMiscService();
